import { render, staticRenderFns } from "./BankDetailsCard.vue?vue&type=template&id=0e41ce38"
import script from "./BankDetailsCard.vue?vue&type=script&lang=js"
export * from "./BankDetailsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports